import i18next from 'i18next'
import {ColumnsType} from 'antd/es/table'
import {DccDataType} from '../models'
import {getAmountWithCurrency} from '~/code/utils'

export const getColumns = (): ColumnsType<DccDataType> => {
    return [
        {
            title: '#',
            key: 'index',
            width: 60,
            render: (_, __, index) => index + 1
        },
        {
            title: i18next.t('DCC.currency'),
            dataIndex: 'cardholderCurrency',
            key: 'currency',
            width: 140
        },
        {
            title: i18next.t('DCC.amountInCC'),
            dataIndex: 'cardholderAmount',
            key: 'cardholderAmount',
            align: 'right',
            width: 180
        },
        {
            title: i18next.t('DCC.acceptedTransactions'),
            dataIndex: 'transactions',
            key: 'transactions',
            align: 'right',
            width: 140,
            render: (value: number) => value
        },
        {
            title: i18next.t('DCC.acceptedAmount'),
            dataIndex: 'convertedAmount',
            key: 'acceptedAmount',
            align: 'right',
            width: 140,
            render: (value: number) => getAmountWithCurrency(value)
        },
        {
            title: i18next.t('DCC.merchantRebate'),
            dataIndex: 'convertedRebateAmount',
            key: 'merchantRebate',
            align: 'right',
            width: 140,
            render: (value: number) => getAmountWithCurrency(value)
        }
    ]
}
